import { Button, Col, Modal, Row, Space } from 'antd';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { Ewo } from '../../models';
import { hasPermission } from '../../utils';
import { UserContext } from '../contexts';
import { EwoEditPage } from './ewo-edit-page';

export function EwoDetailPage(props: { ewo?: Ewo; onSaved: () => void }) {
  const { user } = useContext(UserContext);

  const [ewo, setEwo] = useState(props.ewo);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalEwo, setEditModalEwo] = useState<Ewo>();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'ewos.edit'));
  }, [user]);

  const openEditModal = () => {
    setEditModalEwo(props.ewo);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditModalEwo(undefined);
  };

  const onEwoEditSaved = (ewo?: Ewo) => {
    closeEditModal();
    if (ewo) {
      setEwo(ewo);
    }
    props.onSaved();
  };

  return (
    <>
      <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
        <Row>
          <Col span={8}>EWO no</Col>
          <Col span={16}>{ewo?.ewoNo}</Col>
        </Row>
        <Row>
          <Col span={8}>Ne</Col>
          <Col span={16}>{ewo?.what}</Col>
        </Row>
        <Row>
          <Col span={8}>Ne zaman</Col>
          <Col span={16}>{ewo?.when}</Col>
        </Row>
        <Row>
          <Col span={8}>Tarih / saat</Col>
          <Col span={16}>{moment(ewo?.occuredAt).format('DD.MM.yyyy HH:mm')}</Col>
        </Row>
        <Row>
          <Col span={8}>Nerede</Col>
          <Col span={16}>{ewo?.where}</Col>
        </Row>
        <Row>
          <Col span={8}>Kim</Col>
          <Col span={16}>{ewo?.who?.fullNameId}</Col>
        </Row>
        <Row>
          <Col span={8}>Rutin çalışma</Col>
          <Col span={16}>{ewo?.routineWork ? 'Evet' : 'Hayır'}</Col>
        </Row>
        <Row>
          <Col span={8}>Hangi</Col>
          <Col span={16}>{ewo?.which}</Col>
        </Row>
        <Row>
          <Col span={8}>Nasıl</Col>
          <Col span={16}>{ewo?.howDescription}</Col>
        </Row>
        <Row>
          <Col span={8}>Oluşturma</Col>
          <Col span={16}>{moment(ewo?.createdAt).format('DD.MM.yyyy HH:mm')}</Col>
        </Row>
        <Row>
          <Col span={8}>Oluşturan</Col>
          <Col span={16}>{ewo?.createdBy.fullNameId}</Col>
        </Row>
      </Space>
      {canEdit && (
        <Button onClick={openEditModal} style={{ marginTop: '2rem' }}>
          Düzenle
        </Button>
      )}
      <Modal title="EWO bildirimi" visible={editModalOpen} footer={null} onCancel={closeEditModal} destroyOnClose={true}>
        <EwoEditPage ewo={editModalEwo} onSaved={onEwoEditSaved} />
      </Modal>
    </>
  );
}
